import "./Collapsible.css";

export const Collapsible = ({ buttonText, open, onClick, children }) => {
  return (
    <>
      <button className="collapsible-button" onClick={onClick}>
        {buttonText}
        <div className="collapsible-icon">{open ? "-" : "+"}</div>
      </button>
      <div>
        <p
          className={`collapsible-contents ${!open && "hidden"}`}
          style={{ display: open ? "block" : "none" }}
        >
          {children}
        </p>
      </div>
    </>
  );
};
